
<div v-if="documents" class="mb-5">
    <div class="scroll-area">
        <a
            v-for  = "(document, index) in documents"
            :key   = "index"
            @click = "onSelect(document)"
        >
            <v-hover
                v-slot = "{ hover }"
            >
                <div>
                    <div v-if="dateChanged (index)" class="date-header primary--text v-flex">
                        <div style="font-weight: 500">
                            {{ dateAsString (document.createdDate) }}
                        </div>
                        <v-spacer />

                        <div class="header-title primary--text">
                            Erstellung am / von
                        </div>
                    </div>
                    <p-dms-entry
                        :step-data-id = "stepDataId"
                        :category     = "category"
                        :document     = "document"
                        :hover        = "hover"
                        :compact      = "compact"
                        :index         = "index"
                        :block-indexes = "blockIndex"
                    />
                </div>
            </v-hover>
        </a>
    </div>
</div>
